import React from "react";
import styled from "styled-components/macro";
import Dropzone from "react-dropzone";
import FileUploadBlack from "lib/images/fileUploadBlack.svg";

const DropZoneContainer = styled.div`
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 1em;
  border: 6px dashed #c4c4c4;
  box-sizing: border-box;
`;
const Image = styled.img`
  object-fit: contain;
`;
const StyledDropzone = styled(Dropzone)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: 0.3s color;
  margin: auto;
  width: 100%;
  height: 100%;

  p {
    width: 100%;
    text-align: center;
    margin: 0 0 auto;
  }

  svg {
    margin: auto auto 1em;
    display: block;
  }
  &:hover {
    cursor: pointer;
    color: #2196f3;
  }
`;

const StyledTextField = styled.span`
    /* Work Sans / 24 */
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: #C4C4C4;
    margin-top: 15px;
`;

const SelectFileText = styled.span`
    color: #005AA9;
    text-decoration: none;

    &:hover {
        cursor: pointer;
        text-decoration: underline;
        color: #005aa9a1;
    }
`;

const CancelText = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #005aa9;
  text-decoration: none;
  margin-bottom: 22px;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #005aa9a1;
  }
`;

const FileComponent = ({ cancel, onDrop }) => (
  <DropZoneContainer>
    <StyledDropzone onDrop={onDrop} multiple={false}>
      <Image src={FileUploadBlack} />
      <StyledTextField>
        Drop files here, or <SelectFileText>select a file</SelectFileText>
      </StyledTextField>
    </StyledDropzone>
    <CancelText onClick={cancel}>Cancel</CancelText>
  </DropZoneContainer>
);

export default FileComponent;
